paypal.Buttons.driver('angular', window.angular);

angular
  .module('app', [
    'ui.router',
    'ngResource',
    'ui.bootstrap',
    'pascalprecht.translate',
    'ngCookies',
    'ngSanitize',
    'angularSpinner',
    'textAngular',
    'ngFileUpload',
    'toggle-switch',
    'paypal-buttons',
    'angular-jsvat'
  ])
  .constant('AUTH_EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    notAuthenticated: 'auth-not-authenticated'
  })
  .config(function ($translateProvider) {
    $translateProvider
      .registerAvailableLanguageKeys(['en'], {
        'en_*': 'en'
      })
      .determinePreferredLanguage()
      .fallbackLanguage('en')
      .useLocalStorage()
      .useStaticFilesLoader({
        prefix: 'i18n/locale-',
        suffix: '.json'
      })
      .useSanitizeValueStrategy(null);
  });
